import { extendedPropertyFlags, extendedPropertyKinds, simplifiedTypeCodes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    defaultValue: {
        // field
        label: "Значение по умолчанию",
        inputProps: { name: "defaultValue" },
    },
    displayName: {
        // field
        label: "Название",
        required: true,
        validators: [requiredField],
        inputProps: { name: "displayName" },
    },
    description: {
        // field
        label: "Описание",
        inputProps: { name: "description" },
    },
    domainCode: {
        // field
        label: "DomainCode",
        inputProps: { name: "domainCode" },
    },
    intFlags: {
        // flags
        label: "Флаги",
        inputProps: { name: "intFlags" },
        value: 0,
        flags: extendedPropertyFlags,
    },
    kind: {
        // select
        label: "Тип объекта",
        required: true,
        options: extendedPropertyKinds,
        validators: [requiredField],
        inputProps: { name: "kind" },
    },
    propertyName: {
        // field
        label: "PropertyName",
        required: true,
        validators: [requiredField],
        inputProps: { name: "propertyName" },
    },
    typeCode: {
        // select
        label: "TypeCode",
        options: simplifiedTypeCodes,
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
        inputProps: { name: "typeCode" },
    },
    validationRegexMask: {
        // field
        label: "ValidationRegexMask",
        inputProps: { name: "validationRegexMask" },
    },
    organizationId: {},
    id: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
